

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IShortUser} from "@/model/shortInterfaces";
import {UrlHelper} from "@/helpers/UrlHelper";
import {RawLocation} from "vue-router";

  @Component({
    name: 'ShortUserCard',
  })
  export default class ShortUserCard extends Vue {

    @Prop()
    protected user!: IShortUser;

    get userPageRoute(): RawLocation {
      return {name: 'user', params: {userId: ''+this.user.id}}
    }

  }

